import React from 'react';
import { arrayOf, object, number, func, string } from 'prop-types';
import styled from 'styled-components';
import shortid from 'shortid';
import MediaQuery from 'react-responsive';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Carousel from '../../carousel/Carousel';
import BenefitCarouselItem from './BenefitCarouselItem';
import BenefitItemStacked from './BenefitItemStacked';

const Container = styled.div`
  display: inline-block;
  background-color: #ffffff;
  width: 100%;
`;

const Divider = styled.div`
  width: 64px;
  height: 4px;
  border-radius: 2px;
  background-color: #f78323;
  margin-bottom: 16px;
`;

const Text = styled.h2`
  width: 100%;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 24px;
  line-height: 1.33;
  text-align: center;
  color: #4a4a4a;
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  margin: 64px 0px;
  align-items: center;
  position: relative;
`;

const Benefits = ({
  benefits, selectedCharacteristic, selectCharacteristic, posName, funnelId,
}) => {
  if (benefits.length > 0) {
    return (
      <Container id="benefits">
        <Title>
          <Divider />
          <Text>Como funcionam os destaques</Text>
        </Title>

        {/* Desktop */}
        <MediaQuery minDeviceWidth={769}>
          {benefits.map(benefit => (
            <BenefitItemStacked key={shortid.generate()} benefit={benefit} />
          ))}
        </MediaQuery>

        {/* Mobile */}
        <MediaQuery maxDeviceWidth={768}>
          <Carousel
            mobile
            externalIndex={selectedCharacteristic}
            settings={{ afterChange: current => selectCharacteristic(current) }}
            posName={posName}
            funnelId={funnelId}
          >
            {benefits.map(benefit => (
              <BenefitCarouselItem key={shortid.generate()} benefit={benefit} />
            ))}
          </Carousel>
        </MediaQuery>
      </Container>
    );
  }
  return null;
};

export default Benefits;

Benefits.propTypes = {
  benefits: arrayOf(object),
  selectedCharacteristic: number.isRequired,
  selectCharacteristic: func.isRequired,
  posName: string.isRequired,
  funnelId: string.isRequired,
};

Benefits.defaultProps = {
  benefits: [],
};
